import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import '@shared/styles/global.css';
import { TamaguiProvider } from '@shared/tamagui';

console.log('=== App Starting ===');
console.log('Supabase URL:', import.meta.env.VITE_SUPABASE_URL);
console.log('Supabase Key:', import.meta.env.VITE_SUPABASE_ANON_KEY ? 'Present' : 'Missing');

const root = document.getElementById('root');
console.log('Root element:', root);

if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <TamaguiProvider>
        <App />
      </TamaguiProvider>
    </React.StrictMode>,
  );
  console.log('App rendered');
} else {
  console.error('Root element not found');
}
